// extracted by mini-css-extract-plugin
export default {"title":"X0Ckj6aH","sub-title":"Lt3rmez_","subTitle":"Lt3rmez_","login-box":"CxZvIKrQ","loginBox":"CxZvIKrQ"};